interface VenueCTABarProps {
  phone: string;
  address: string;
  lat: number;
  lng: number;
  venueName: string;
}

export default function VenueCTABar({ phone, address, lat, lng, venueName }: VenueCTABarProps) {
  const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
  const shareText = encodeURIComponent(`${venueName} - ${address} | Bursa Guide 360`);
  const shareUrl = encodeURIComponent(window.location.href);

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title: venueName, text: address, url: window.location.href });
      } catch {
        // cancelled
      }
    } else {
      window.open(`https://wa.me/?text=${shareText}%20${shareUrl}`, "_blank");
    }
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 bg-white/95 backdrop-blur-md border-t border-stone-100 px-4 py-3 md:hidden">
      <div className="flex gap-3 max-w-lg mx-auto">
        {phone && (
          <a
            href={`tel:${phone}`}
            className="flex-1 flex items-center justify-center gap-2 bg-stone-100 hover:bg-stone-200 text-stone-700 rounded-xl py-2.5 text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-phone-line text-base" />
            Ara
          </a>
        )}
        <a
          href={directionsUrl}
          target="_blank"
          rel="nofollow noreferrer"
          className="flex-1 flex items-center justify-center gap-2 bg-emerald-700 hover:bg-emerald-800 text-white rounded-xl py-2.5 text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-navigation-line text-base" />
          Yol Tarifi
        </a>
        <button
          onClick={handleShare}
          className="w-11 h-11 flex items-center justify-center bg-stone-100 hover:bg-stone-200 text-stone-700 rounded-xl transition-colors cursor-pointer flex-shrink-0"
        >
          <i className="ri-share-line text-lg" />
        </button>
      </div>
    </div>
  );
}
